export default __webpack_public_path__ + "static/media/09.49923a8c.jpg";